<template>
    <transition name="el-zoom-in-top">
    <div class="transition-box" v-show="showDiv">
        <div style="border-bottom:0.1px solid #EEE9E9;">
            <el-row>
            <el-col :span="2" style="border-right: solid 0.1px #EEE9E9;">
                    <span>
                        <h1 style="float: left">
                            <el-link @click="check" icon="el-icon-arrow-left" style="font-size: 25px;font-weight:bold;color: #4f94cd" >报名查询</el-link>
                        </h1>
                    </span>
            </el-col>

            <el-col :span="22"><span><h1 style="text-align: center">2023鼓楼区小学生象棋锦标赛个人报名  </h1></span></el-col><!--特殊设置关键词：省赛-->
            </el-row>
        </div>



        <el-form ref="elForm" :model="formData" :rules="rules" size="medium" label-width="100px"
                 label-position="left">
            <el-row type="flex" justify="center" align="top" style="border-bottom:0.1px solid #EEE9E9;" >
                <el-col :span="10" style="margin-top: 20px">
                    <el-form-item label="学生姓名" prop="title">
                        <el-input v-model="formData.title" placeholder="请输入学生姓名" clearable :style="{width: '100%'}">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row type="flex" justify="center" align="top" style="border-bottom:0.1px solid #EEE9E9;" >
                <el-col :span="10" style="margin-top: 20px">
                    <el-form-item label="出生日期" prop="birthday">
                        <!--<el-input v-model="formData.birthday" placeholder="请输入出生日期" clearable :style="{width: '100%'}">
                        </el-input>-->
                        <el-date-picker type="date" placeholder="选择出生日期" v-model="formData.birthday" style="width: 100%;"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row type="flex" justify="center" align="top" style="border-bottom:0.1px solid #EEE9E9;">
                <el-col :span="10" style="margin-top: 20px">
                    <el-form-item label="身份证号" prop="idNumber">
                        <el-input v-model="formData.idNumber" placeholder="请输入身份证号" clearable :style="{width: '100%'}">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row type="flex" justify="center" align="middle" style="border-bottom:0.1px solid #EEE9E9;">
                <el-col :span="10" style="margin-top: 20px">
                    <el-form-item label="性别" prop="sex">
                        <el-radio-group v-model="formData.sex" size="medium">
                            <el-radio v-for="(item, index) in typeOptions" :key="index" :label="item.value"
                                      :disabled="item.disabled">{{item.label}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row type="flex" justify="center" align="top" style="border-bottom:0.1px solid #EEE9E9;">
                <el-col :span="10" style="margin-top: 20px">
                    <el-form-item label="分组"  prop="grade"  >
                        <el-select v-model="formData.gradeName" placeholder="请选择分组" clearable :style="{width: '100%'}">
                            <el-option v-for="(item, index) in gradeItems" :key="index" :label="item.label"
                                       :value="item.value" :disabled="item.disabled"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row type="flex" justify="center" align="top" style="border-bottom:0.1px solid #EEE9E9;">
                <el-col :span="10" style="margin-top: 20px">
                    <el-form-item label="就读学校" prop="school">
                        <el-input v-model="formData.school" placeholder="请输入就读学校" clearable :style="{width: '100%'}">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row type="flex" justify="center" align="top" style="border-bottom:0.1px solid #EEE9E9;">
                <el-col :span="10" style="margin-top: 20px">
                    <el-form-item label="监护人姓名" prop="des" >
                        <el-input v-model="formData.des" placeholder="请输入监护人姓名" clearable :style="{width: '100%'}">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>


            <!--所属团体弹出框-->
            <el-row type="flex" justify="center" align="top" style="border-bottom:0.1px solid #EEE9E9;" v-show="false">
                <el-col :span="10" style="margin-top: 20px">
                    <el-form-item label="所属团体" prop="org" >
                        <el-input disabled v-model="formData.org" placeholder="请选择所属团体"  @focus="onOpen()" readonly clearable :style="{width: '100%'}">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-dialog :close-on-click-modal="false"  :visible="dialogVisible"  @close="onClose" title="所属团体"><!-- @open="onOpen" v-bind="$attrs" v-on="$listeners"-->

                    <el-row type="flex" justify="center" align="top">
                        <el-col :span="10">
                            <el-input placeholder="请输入团体代码查询" v-model="searchKey" class="input-with-select">
                                <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
                            </el-input>
                        </el-col>
                    </el-row>

                <el-row type="flex" justify="center" align="top">
                        <el-table
                                :data="tableData"
                                border
                                style="margin-top: 30px;">
                            <el-table-column
                                    fixed
                                    prop="title"
                                    label="团体名称">
                            </el-table-column>
                            <el-table-column
                                    prop="code"
                                    label="团体代码">
                            </el-table-column>
                            <el-table-column
                                    prop="type"
                                    label="团体类型">
                            </el-table-column>
                            <el-table-column
                                    fixed="right"
                                    label="操作">
                                <template slot-scope="scope">
                                    <el-button @click="rowClick(scope.row)" type="text" size="medium">选择</el-button>
                                   <!-- <el-button type="text" size="small">编辑</el-button>-->
                                </template>
                            </el-table-column>
                        </el-table>
                </el-row>



                <div slot="footer">
                    <el-button @click="close">取消</el-button>
                    <el-button type="primary" @click="handelConfirm">确定</el-button>
                </div>
            </el-dialog>
            <!--弹出框end-->


            <!--完成后弹出群二维码-->
            <el-dialog :close-on-click-modal="false"  :visible="qrVisible"  @close="qrClose" title="群二维码"><!-- @open="onOpen" v-bind="$attrs" v-on="$listeners"-->


                <el-image :src="'http://img.tmxiangqi.com/enrollQrCode.jpg?20230726'">
                    <div slot="placeholder" class="image-slot">
                        加载中<span class="dot">...</span>
                    </div>
                </el-image>


                <div slot="footer">
                    <el-button type="primary" @click="qrClose">确定</el-button>
                </div>
            </el-dialog>

            <!--二维码end-->



            <el-row type="flex" justify="center" align="top"   style="border-bottom:0.1px solid #EEE9E9;">
                <el-col :span="10" style="margin-top: 20px">
                    <el-form-item label="身份证或户口本" prop="field119" required ><!--:action="field119Action"-->
                        <el-upload  ref="field119"
                                    :file-list="file1List"
                                    action="string"
                                    :auto-upload="false"
                                    :limit="1"
                                    :on-preview="getEditFile"
                                    :on-exceed="handlerExceed"
                                    :on-change="file1Upload" list-type="picture" accept="image/*,application/pdf">
                            <el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip" style="color: red">只能上传小于10Mb的文件;文件格式：jpg,png,pdf</div>
                        </el-upload>
                    </el-form-item>
                </el-col>
            </el-row>

            <!--省赛无需学籍证明 其它比赛可能要-->
            <!--<el-row type="flex" justify="center" align="center" style="border-bottom:0.1px solid #EEE9E9;">
                <el-col :span="10" style="margin-top: 20px">
                    <el-form-item label="学籍证明" prop="field120" required>
                        <el-upload ref="field120"
                                   :file-list="file2List"
                                   action="string"
                                   :auto-upload="false"
                                   :limit="1"
                                   :on-exceed="handlerExceed"
                                   :on-change="file2Upload" list-type="picture" accept="image/*,application/pdf">
                            <el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip" style="color: red">只能上传小于10Mb的文件;文件格式：jpg,png,pdf</div>
                        </el-upload>
                    </el-form-item>
                </el-col>
            </el-row>-->

            <el-row type="flex" justify="center" align="top" style="border-bottom:0.1px solid #EEE9E9;">
                <el-col :span="10" style="margin-top: 20px">
                    <el-form-item label="赛事期间人身意外伤害保险单据" prop="field122" required>
                        <el-upload ref="field122"
                                   :file-list="file3List"
                                   action="string"
                                   :auto-upload="false"
                                   :limit="1"
                                   :on-exceed="handlerExceed"
                                   :on-change="file3Upload" list-type="picture" accept="image/*,application/pdf">
                            <el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip" style="color: red">只能上传小于10Mb的文件;文件格式：jpg,png,pdf</div>
                        </el-upload>
                    </el-form-item>
                </el-col>
            </el-row>
            <!--el-row type="flex" justify="center" align="top" style="border-bottom:0.1px solid #EEE9E9;">
                <el-col :span="10"  style="margin-top: 20px">
                    <el-form-item label="个人证件照" prop="field125">
                        <el-upload ref="field125"
                                   :file-list="file4List"
                                   action="string"
                                   :auto-upload="false"
                                   :limit="1"
                                   :on-exceed="handlerExceed"
                                   :on-change="file4Upload" list-type="picture" accept="image/*,application/pdf">
                            <el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip" style="color: red">只能上传小于10Mb的文件;文件格式：jpg,png,pdf</div>
                        </el-upload>
                    </el-form-item>
                </el-col>
            </el-row>-->

            <el-row type="flex" justify="center" align="top" style="border-bottom:0.1px solid #EEE9E9;">
                <el-col :span="10"  style="margin-top: 20px">
                    <el-form-item label="获奖证书（跨龄参赛必填）" prop="field126">
                        <el-upload ref="field126"
                                   :file-list="file5List"
                                   action="string"
                                   :auto-upload="false"
                                   :limit="1"
                                   :on-exceed="handlerExceed"
                                   :on-change="file5Upload" list-type="picture" accept="image/*,application/pdf">
                            <el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip" style="color: red">只能上传小于10Mb的文件;文件格式：jpg,png,pdf</div>
                        </el-upload>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row type="flex" justify="center" align="top" style="border-bottom:0.1px solid #EEE9E9;">
                <el-col :span="10"  style="margin-top: 20px">
                    <el-form-item label="等级证书（8-16 岁组必填）" prop="field127">
                        <el-upload ref="field127"
                                   :file-list="file7List"
                                   action="string"
                                   :auto-upload="false"
                                   :limit="1"
                                   :on-exceed="handlerExceed"
                                   :on-change="file7Upload" list-type="picture" accept="image/*,application/pdf">
                            <el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip" style="color: red">只能上传小于10Mb的文件;文件格式：jpg,png,pdf</div>
                        </el-upload>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row type="flex" justify="center" align="top"   style="border-bottom:0.1px solid #EEE9E9;">
                <el-col :span="10" style="margin-top: 20px">
                    <el-form-item label="转账证明" prop="field133" required ><!--:action="field119Action"-->
                        <el-upload  ref="field133"
                                    :file-list="file6List"
                                    action="string"
                                    :auto-upload="false"
                                    :limit="1"
                                    :on-preview="getEditFile"
                                    :on-exceed="handlerExceed"
                                    :on-change="file6Upload" list-type="picture" accept="image/*,application/pdf">
                            <el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip" style="color: red">只能上传小于10Mb的文件;文件格式：jpg,png,pdf</div>
                        </el-upload>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row type="flex" justify="center" align="top" style="border-bottom:0.1px solid #EEE9E9;">
                <el-col :span="10" style="margin-top: 20px">
                    <el-form-item label="手机号" prop="phone">
                        <el-input v-model="formData.phone" :disabled="isEdit" @blur="validatePhone" placeholder="请输入手机号" clearable :style="{width: '100%'}">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row type="flex" justify="center" align="top" >
                <el-col :span="10" style="margin-top: 20px">
                    <el-form-item label="短信验证码" prop="captcha">
                        <el-input v-model="formData.captcha" placeholder="请输入短信验证码" clearable :style="{width: '100%'}">
                            <template slot="append">
                                <el-button type="primary" v-if="unSend" style="background-color: dodgerblue;color: white" @click="sendSms" v-preventReClick>发送验证码</el-button>
                                <el-button type="primary" v-else style="background-color: dodgerblue;color: white" >{{smsTime}}</el-button>
                            </template>
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item size="large">
                <el-button v-if="!isEdit" type="primary" @click="doAdd" v-loading.fullscreen.lock="showLoad" v-preventReClick>报名</el-button>
                <el-button v-else type="primary" @click="doEdit" v-loading.fullscreen.lock="showLoad" v-preventReClick>修改</el-button>
                <el-button @click="resetForm">重置</el-button>
                <el-button v-if="isEdit" type="primary" @click="cancelEdit" v-loading.fullscreen.lock="showLoad" v-preventReClick>退出修改</el-button>
                <!--<el-button type="primary" @click="check"  v-preventReClick>报名查询</el-button>-->
            </el-form-item>
        </el-form>

        <el-dialog title="报名查询" :visible.sync="showCheck" :fullscreen="false"  :center="true">
            <el-form  size="medium" label-width="100px" label-position="left">
            <el-row type="flex" justify="center" align="top" style="border-bottom:0.1px solid #EEE9E9;" >
                <el-col :span="10" style="margin-top: 20px">
                    <el-form-item label="学生姓名" prop="title">
                        <el-input v-model="formData.checkTitle" placeholder="请输入学生姓名" clearable :style="{width: '100%'}">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
                <el-row type="flex" justify="center" align="top" style="border-bottom:0.1px solid #EEE9E9;">
                    <el-col :span="10" style="margin-top: 20px">
                        <el-form-item label="手机号" prop="phone">
                            <el-input v-model="formData.checkPhone" @blur="validatePhone" placeholder="请输入手机号" clearable :style="{width: '100%'}">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row type="flex" justify="center" align="top" >
                    <el-col :span="10" style="margin-top: 20px">
                        <el-form-item label="短信验证码" prop="captcha">
                            <el-input v-model="formData.checkCaptcha" placeholder="请输入短信验证码" clearable :style="{width: '100%'}">
                                <template slot="append">
                                    <el-button type="primary" v-if="unSend" v-preventReClick  style="background-color: dodgerblue;color: white" @click="sendCheckSms">发送验证码</el-button>
                                    <el-button type="primary" v-else style="background-color: dodgerblue;color: white" >{{smsTime}}</el-button>
                                </template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>


                <el-steps :active="step" align-center v-show="showProgress"  style="margin-top: 28px"   ><!--:finish-status="'success'"-->
                    <el-step :title="'提交报名信息'" :description="'【'+checkItem.grade+'】\xa0'+checkItem.createTime"  ></el-step>
                    <el-step title="报名信息审核中"   description=""  >

                        <span slot="description" style="color: red"   >修改意见：{{checkItem.summary}}</span>
                    </el-step>
                    <el-step title="审核通过报名成功" description="" ></el-step>
                </el-steps>
            </el-form>


            <span slot="footer"  class="dialog-footer"  >
                    <el-button   type="primary" @click="doQuery">查询</el-button>
                    <el-button   type="primary" @click="doUpdate">修改资料</el-button>
            </span>
        </el-dialog>

       <!-- <el-image
                style="width: 100px; height: 100px"
                :src="this.file1Img"
                :load="getLoad">
        </el-image>-->

    </div>
    </transition>
</template>
<script>
    import { getAction, postAction,httpAction } from '../../api/manage';
    import preventReClick from '../../utils/preventReClick';
    export default {
        components: {},
        props: [],
        data() {
            return {
                formData: {
                    title: "",
                    orgUser: "",
                    type: "男",
                    phone: "",
                    captcha: "",
                    file1:null,
                    file2:null,
                    file3:null,
                    file4:null,
                    file5:null,
                    file6:null,
                    file7:null,
                    gradeName:"",
                    school:"",
                    des:"",
                    org:"",
                    orgCode:"",
                    idNumber:"",
                    sex:"男",
                    checkTitle:"",
                    checkCaptcha:"",
                    checkPhone:"",
                    id:'',
                    birthday:''

                },
                file1List: [],
                file2List: [],
                file3List: [],
                file4List: [],
                file5List: [],
                file6List: [],
                file7List: [],


                matchId:"5",
                file1Img:"",
                isEdit:false,
                checkItem:{grade:'',createTime:'',summary:'',title:'',school:'',org:'',orgCode:'',sex:'',des:'',idPath:'',id:''},
                step:1,
                showProgress:false,
                showCheck:false,
                showDiv:false,
                qrVisible:false,
                showLoad:false,
                finished:false,
                dialogVisible:false,
                searchKey:"",
                smsTime:0,
                unSend:true,
                isPhone:false,
                phoneMessage:"",
                smsTxt:"发送验证码",

                gradeItems: [{
                    "label": "18 岁组（青年组）",
                    "value":  "18 岁组（青年组）"
                }, {
                    "label": "16 岁组（少年甲组）",
                    "value": "16 岁组（少年甲组）"
                }, {
                    "label": "14 岁组（少年乙组）",
                    "value": "14 岁组（少年乙组）"
                }, {
                    "label": "12 岁组（少年丙组）",
                    "value": "12 岁组（少年丙组）"
                }, {
                    "label": "10 岁组（儿童甲组）",
                    "value": "10 岁组（儿童甲组）"
                }, {
                    "label": "9 岁组（儿童乙组）",
                    "value": "9 岁组（儿童乙组）"
                }, {
                    "label": "8 岁组（儿童丙组）",
                    "value": "8 岁组（儿童丙组）"
                }, {
                    "label": "7 岁组（儿童丁组）",
                    "value": "7 岁组（儿童丁组）"
                }],

                tableData: [],

                rules: {
                    title: [{
                        required: true,
                        message: '请输入团体名称',
                        trigger: 'blur'
                    }],
                    grade: [{
                        required: true,
                        message: '请选择分组',
                        trigger: 'blur'
                    }],
                    school: [{
                        required: true,
                        message: '请输入就读学校',
                        trigger: 'blur'
                    }],
                    orgUser: [{
                        required: true,
                        message: '请输入领队姓名',
                        trigger: 'blur'
                    }],
                    type: [{
                        required: true,
                        message: '团体性质不能为空',
                        trigger: 'change'
                    }],
                    phone: [{
                        required: true,
                        message: '请输入领队手机号',
                        trigger: 'blur'
                    }],
                    captcha: [{
                        required: true,
                        message: '请输入短信验证码',
                        trigger: 'blur'
                    }],
                },
                typeOptions: [{
                    "label": "男",
                    "value": "男"
                }, {
                    "label": "女",
                    "value": "女"
                }],
            }
        },
        computed: {},
        watch: {},
        created() {
            /////验证码计时
            this.smsTime =   window.localStorage.getItem("smsTime");
            if(this.smsTime!=null&&this.smsTime!=0&&typeof(this.smsTime)!="undefined"){
                this.unSend=false;
                let timer = setInterval(() => {
                    this.smsTime--
                    window.localStorage.setItem("smsTime",this.smsTime);
                    if (this.smsTime <= 0) {
                        this.smsTime=0;
                        clearInterval(timer)
                        this.unSend = true;
                    }
                }, 1000);
            }

            //////////////////个人赛专属团体(2023省赛专用？)//////////////////////////
            this.formData.org = "2023年福建省青少年象棋精英赛个人报名团体";
            this.formData.orgCode = "385322";
            /////////////////////////////////////////////////////////////////////
        },
        mounted() {this.showDiv=true},
        methods: {
            doQuery(){
                let params = {
                    title: this.formData.checkTitle,
                    phone:this.formData.checkPhone,
                    captcha: this.formData.checkCaptcha

                };
                let that = this;
                getAction("/sys/competition/check",params).then((res) => {
                    if (res.success) {
                        that.checkItem = res.result;
                        that.step=1;
                        if(that.checkItem.fstatus!=""&&typeof(that.checkItem.fstatus)!="undefined"){
                            that.step = parseInt(that.checkItem.fstatus)+1;
                        }
                        that.showProgress=true;
                    }else{
                        that.showMessage(1,res.message);
                        return;
                    }

                });


            },

            check(){
                this.showCheck=true;

            },

            showMessage(type,msg){
                if(type==0){
                    this.$message({
                        message: msg,
                        type: 'success'
                    });
                }
                else{
                    this.$message.error(msg);
                }

            },

            sendSms(){
                if(!this.validatePhone()){
                    this.showMessage(1,"请填写正确手机号！")
                }
                else{
                    let params = {
                        phone:this.formData.phone
                    }
                    postAction("/sys/sendSms",params).then((res) => {
                        if (res.success) {
                            this.smsTime= 180;//*1000;
                            this.showMessage(0,"验证码发送成功！");

                            this.unSend = false;
                            this.smsTime=180;
                            let timer = setInterval(() => {
                                this.smsTime--
                                window.localStorage.setItem("smsTime",this.smsTime);
                                if (this.smsTime === 0) {
                                    clearInterval(timer)
                                    this.unSend = true;
                                }
                            }, 1000);
                            return;
                        } else {
                            this.showMessage(1,"验证码发送失败！");
                            return;
                        }
                    })
                }


            },

            sendCheckSms(){
                if(!this.validateCheckPhone()){
                    this.showMessage(1,"请填写正确手机号！")
                }
                else{
                    let params = {
                        phone:this.formData.checkPhone
                    }
                    postAction("/sys/sendSms",params).then((res) => {
                        if (res.success) {
                            this.smsTime= 180;//*1000;
                            this.showMessage(0,"验证码发送成功！");

                            this.unSend = false;
                            this.smsTime=180;
                            let timer = setInterval(() => {
                                this.smsTime--
                                window.localStorage.setItem("smsTime",this.smsTime);
                                if (this.smsTime === 0) {
                                    clearInterval(timer)
                                    this.unSend = true;
                                }
                            }, 1000);
                            return;
                        } else {
                            this.showMessage(1,"验证码发送失败！");
                            return;
                        }
                    })
                }


            },

            validatePhone(){
                if(!this.formData.phone){
                    this.phoneMessage="请填写手机号！";
                    this.isPhone=false;
                    return false;
                }else{
                    //update-begin--Author:kangxiaolin  Date:20190826 for：[05] 手机号不支持199号码段--------------------
                    if(new RegExp(/^1[3|4|5|7|8|9][0-9]\d{8}$/).test(this.formData.phone)){
                        //update-end--Author:kangxiaolin  Date:20190826 for：[05] 手机号不支持199号码段--------------------
                        this.phoneMessage = "";
                        this.isPhone=true;
                        return  true;

                    }else{
                        this.phoneMessage = "请输入正确格式的手机号码!";
                        this.isPhone=false;
                        return false;
                    }
                }
                this.phoneMessage ="";
                this.isPhone=true;
                return true;
            },

            validateCheckPhone(){
                if(!this.formData.checkPhone){
                    //this.phoneMessage="请填写手机号！";
                    //this.isPhone=false;
                    return false;
                }else{
                    //update-begin--Author:kangxiaolin  Date:20190826 for：[05] 手机号不支持199号码段--------------------
                    if(new RegExp(/^1[3|4|5|7|8|9][0-9]\d{8}$/).test(this.formData.checkPhone)){
                        //update-end--Author:kangxiaolin  Date:20190826 for：[05] 手机号不支持199号码段--------------------
                        //this.phoneMessage = "";
                        //this.isPhone=true;
                        return  true;

                    }else{
                        //this.phoneMessage = "请输入正确格式的手机号码!";
                        //this.isPhone=false;
                        return false;
                    }
                }
                //this.phoneMessage ="";
                //this.isPhone=true;
                return true;
            },




            handlerExceed(files,fileList){
                this.$message.error("只允许上传单个文件，请先取消上个文件再上传！")
            },


            file1Upload(file,fileList) {
                console.log("test");
                let isRightSize = file.size / 1024 / 1024 < 10
                if (!isRightSize) {
                    this.$message.error('文件大小超过 10MB')
                }
                let isAccept = new RegExp('image/jpeg|image/png|application/pdf').test(file.raw.type)
                if (!isAccept) {
                    this.showMessage(1,'请选择jpg,png或pdf类型的文件')
                }
                if(isRightSize&&isAccept){
                    this.file1List = fileList;
                    this.formData.file1 = file.raw;
                    if(file.raw.type!="application/pdf"){
                        this.imgPreview(file.raw,"1");
                    }
                }

                return isRightSize && isAccept
            },
            file2Upload(file,fileList) {
                let isRightSize = file.size / 1024 / 1024 < 10
                if (!isRightSize) {
                    this.$message.error('文件大小超过 10MB')
                }
                let isAccept = new RegExp('image/jpeg|image/png|application/pdf').test(file.raw.type)
                if (!isAccept) {
                    this.showMessage(1,'请选择jpg,png或pdf类型的文件')
                }
                if(isRightSize&&isAccept){
                    this.file2List = fileList;
                    this.formData.file2 = file.raw;
                    if(file.raw.type!="application/pdf"){
                        this.imgPreview(file.raw,"2");
                    }
                }
                return isRightSize && isAccept
            },
            file3Upload(file,fileList) {
                let isRightSize = file.size / 1024 / 1024 < 10
                if (!isRightSize) {
                    this.$message.error('文件大小超过 10MB')
                }
                let isAccept = new RegExp('image/jpeg|image/png|application/pdf').test(file.raw.type)
                if (!isAccept) {
                    this.showMessage(1,'请选择jpg,png或pdf类型的文件')
                }

                if(isRightSize&&isAccept){
                    this.file3List = fileList;
                    this.formData.file3 = file.raw;
                    if(file.raw.type!="application/pdf"){
                        this.imgPreview(file.raw,"3");
                    }
                }
                return isRightSize && isAccept
            },
            file4Upload(file,fileList) {
                let isRightSize = file.size / 1024 / 1024 < 10
                if (!isRightSize) {
                    this.$message.error('文件大小超过 10MB')
                }
                let isAccept = new RegExp('image/jpeg|image/png|application/pdf').test(file.raw.type)
                if (!isAccept) {
                    this.showMessage(1,'请选择jpg,png或pdf类型的文件')
                }

                if(isRightSize&&isAccept){
                    this.file4List = fileList;
                    this.formData.file4 = file.raw;
                    if(file.raw.type!="application/pdf"){
                        this.imgPreview(file.raw,"4");
                    }
                }
                return isRightSize && isAccept
            },
            file5Upload(file,fileList) {
                let isRightSize = file.size / 1024 / 1024 < 10
                if (!isRightSize) {
                    this.$message.error('文件大小超过 10MB')
                }
                let isAccept = new RegExp('image/jpeg|image/png|application/pdf').test(file.raw.type)
                if (!isAccept) {
                    this.showMessage(1,'请选择jpg,png或pdf类型的文件')
                }

                if(isRightSize&&isAccept){
                    this.file5List = fileList;
                    this.formData.file5 = file.raw;
                    if(file.raw.type!="application/pdf"){
                        this.imgPreview(file.raw,"5");
                    }
                }
                return isRightSize && isAccept
            },

            file6Upload(file,fileList) {
                let isRightSize = file.size / 1024 / 1024 < 10
                if (!isRightSize) {
                    this.$message.error('文件大小超过 10MB')
                }
                let isAccept = new RegExp('image/jpeg|image/png|application/pdf').test(file.raw.type)
                if (!isAccept) {
                    this.showMessage(1,'请选择jpg,png或pdf类型的文件')
                }
                if(isRightSize&&isAccept){
                    this.file6List = fileList;
                    this.formData.file6 = file.raw;
                    if(file.raw.type!="application/pdf"){
                        this.imgPreview(file.raw,"6");
                    }
                }
                return isRightSize && isAccept
            },

            file7Upload(file,fileList) {
                let isRightSize = file.size / 1024 / 1024 < 10
                if (!isRightSize) {
                    this.$message.error('文件大小超过 10MB')
                }
                let isAccept = new RegExp('image/jpeg|image/png|application/pdf').test(file.raw.type)
                if (!isAccept) {
                    this.showMessage(1,'请选择jpg,png或pdf类型的文件')
                }
                if(isRightSize&&isAccept){
                    this.file7List = fileList;
                    this.formData.file7 = file.raw;
                    if(file.raw.type!="application/pdf"){
                        this.imgPreview(file.raw,"7");
                    }
                }
                return isRightSize && isAccept
            },


            doAdd() {
                let that = this;


                //////////////////个人赛专属团体(2023省赛专用？)//////////////////////////
                this.formData.org = "2023年福建省青少年象棋精英赛个人报名团体";
                this.formData.orgCode = "385322";
                /////////////////////////////////////////////////////////////////////
                if (this.formData.title == "") {
                    this.showMessage(1, "请输入姓名");
                    return;
                }

                if (this.formData.idNumber == "") {
                    this.showMessage(1, "请输入身份证号");
                    return;
                }

                if (this.formData.gradeName == "") {
                    this.showMessage(1, "请选择分组");
                    return;
                }

                if (this.formData.school == "") {
                    this.showMessage(1, "请输入就读学校");
                    return;
                }

                if (this.formData.org == "") {
                    this.showMessage(1, "请选择所属团体");
                    return;
                }

                if (this.formData.birthday == ""||this.formData.birthday==null) {
                    this.showMessage(1, "请输入出生日期");
                    return;
                }
                /////出生日期格式化
                let formatBirth = this.formData.birthday;
                let year = formatBirth.getFullYear(); //得到年份
                let month = formatBirth.getMonth(); //得到月份
                let date = formatBirth.getDate(); //得到日期
                month = month + 1;
                if (month < 10) month = "0" + month;
                if (date < 10) date = "0" + date;
                let birth = year + "-" + month + "-" + date;


                let params = {
                    matchId: this.matchId,
                    title: this.formData.title,
                    idNumber: this.formData.idNumber,
                    sex: this.formData.sex,
                    des: this.formData.des,
                    phone: this.formData.phone,
                    school: this.formData.school,
                    grade: this.formData.gradeName,
                    org: this.formData.org,
                    orgCode: this.formData.orgCode,
                    createBy: "网页端",
                    captcha: this.formData.captcha,
                    birthday:birth

                };


                let fileParams = new FormData()
                let file1 = this.formData.file1;
                let file2 = this.formData.file2;
                let file3 = this.formData.file3;
                let file4 = this.formData.file4;
                let file5 = this.formData.file5;
                let file6 = this.formData.file6;
                let file7 = this.formData.file7;

                let type1 = "";
                let type2 = "";
                let type3 = "";
                let type4 = "";
                let type5 = "";
                let type6 = "";
                let type7 = "";


                if (file1 != [] && file1 != null && typeof (file1) != "undefined") {
                    type1 = file1.name.substring(file1.name.lastIndexOf("."));
                    fileParams.append('files', file1, "idPath" + type1);
                } else {
                    this.showMessage(1, "请上传身份证或户口本！");
                    return;
                }

                /*省赛无需学籍证明 其它比赛可能要*/
                /*if (file2 != [] && file2 != null && typeof (file2) != "undefined") {
                    type2 = file2.name.substring(file2.name.lastIndexOf("."));
                    fileParams.append('files', file2, "studentPath" + type2);
                } else {
                    this.showMessage(1, "请上传学籍证明！");
                    return;
                }*/


                if (file3 != [] && file3 != null && typeof (file3) != "undefined") {
                    type3 = file3.name.substring(file3.name.lastIndexOf("."));
                    fileParams.append('files', file3, "insurancePath" + type3);
                } else {
                    this.showMessage(1, "请上传保险单据！");
                    return;
                }
                if (file4 != [] && file4 != null && typeof (file4) != "undefined") {
                    type4 = file4.name.substring(file4.name.lastIndexOf("."));
                    fileParams.append('files', file4, "photoPath" + type4);
                }


                if (file5 != [] && file5 != null && typeof (file5) != "undefined") {
                    type5 = file5.name.substring(file5.name.lastIndexOf("."));
                    fileParams.append('files', file5, "certPath" + type5);
                }

                if (file6 != [] && file6 != null && typeof (file6) != "undefined") {
                    type6 = file6.name.substring(file6.name.lastIndexOf("."));
                    fileParams.append('files', file6, "chargePath" + type6);
                } else {
                    this.showMessage(1, "请上传转账证明！");
                    return;
                }

                if (file7 != [] && file7 != null && typeof (file7) != "undefined") {
                    type7 = file7.name.substring(file7.name.lastIndexOf("."));
                    fileParams.append('files', file7, "rankPath" + type7);
                }else {
                    if(this.formData.gradeName!="7 岁组（儿童丁组）"){
                        this.showMessage(1, "请上传等级证书！");
                        return;
                    }

                }


                this.showLoad = true;
                let header = "Content-Type': 'multipart/form-data";
                let mobile = that.formData.phone+","+this.matchId+","+'N';
                setTimeout(function () {
                postAction("/sys/competition/importImg/" + mobile, fileParams, header).then((res) => {
                    that.showLoad = false;
                    if (res.success) {
                        params["idPath"] = res.result.idPath;
                        params["studentPath"] = res.result.studentPath;
                        params["insurancePath"] = res.result.insurancePath;
                        params["certPath"] = res.result.certPath;
                        params["rankPath"] = res.result.rankPath;
                        params["photoPath"] = res.result.photoPath;
                        params["chargePath"] = res.result.chargePath;
                        postAction("/sys/competition/add", params).then((res) => {
                            if (res.success) {
                                that.formData.file1 = null;
                                that.formData.file2 = null;
                                that.formData.file3 = null;
                                that.formData.file4 = null;
                                that.formData.file5 = null;
                                that.formData.file6 = null;
                                that.formData.file7 = null;
                                this.file1List = [];
                                this.file2List = [];
                                this.file3List = [];
                                this.file4List = [];
                                this.file5List = [];
                                this.file6List = [];
                                this.file7List = [];
                                that.formData.title = "";
                                that.formData.phone = "";
                                that.formData.captcha = "";
                                that.formData.gradeName = "";
                                that.resetForm();

                                let code = res.result;
                                that.qrVisible = true;
                                /* that.$router.push({
                                    name: 'teamResult',
                                    params: { code: code},
                                    query:{t:Date.now()}
                                });*/

                                that.showMessage(0, "上传成功");

                                return;
                            } else {
                                that.showMessage(1, res.message);
                                return;
                            }
                        })

                    } else {
                        that.showLoad = false;
                        that.showMessage(1, "上传失败：" + res.message);
                    }


                });
            },1000);

            },

            doEdit() {
                let that = this;

                //////////////////个人赛专属团体(2023省赛专用？)//////////////////////////
                this.formData.org = "2023年福建省青少年象棋精英赛个人报名团体";
                this.formData.orgCode = "385322";
                /////////////////////////////////////////////////////////////////////
                if (this.formData.title == "") {
                    this.showMessage(1, "请输入姓名");
                    return;
                }

                if (this.formData.idNumber == "") {
                    this.showMessage(1, "请输入身份证号");
                    return;
                }

                if (this.formData.gradeName == "") {
                    this.showMessage(1, "请选择分组");
                    return;
                }

                if (this.formData.school == "") {
                    this.showMessage(1, "请输入就读学校");
                    return;
                }

                if (this.formData.org == "") {
                    this.showMessage(1, "请选择所属团体");
                    return;
                }

                if (this.formData.birthday == ""||this.formData.birthday==null) {
                    this.showMessage(1, "请输入出生日期");
                    return;
                }
                /////出生日期格式化
                let formatBirth = this.formData.birthday;
                let year = formatBirth.getFullYear(); //得到年份
                let month = formatBirth.getMonth(); //得到月份
                let date = formatBirth.getDate(); //得到日期
                month = month + 1;
                if (month < 10) month = "0" + month;
                if (date < 10) date = "0" + date;
                let birth = year + "-" + month + "-" + date;


                let params = {
                    matchId: this.matchId,
                    id: this.formData.id,
                    title: this.formData.title,
                    idNumber: this.formData.idNumber,
                    sex: this.formData.sex,
                    des: this.formData.des,
                    phone: this.formData.phone,
                    school: this.formData.school,
                    grade: this.formData.gradeName,
                    org: this.formData.org,
                    orgCode: this.formData.orgCode,
                    createBy: "网页端",
                    captcha: this.formData.captcha,
                    birthday:birth

                };


                let fileParams = new FormData()
                let file1 = this.formData.file1;
                let file2 = this.formData.file2;
                let file3 = this.formData.file3;
                let file4 = this.formData.file4;
                let file5 = this.formData.file5;
                let file6 = this.formData.file6;
                let file7 = this.formData.file7;

                let type1 = "";
                let type2 = "";
                let type3 = "";
                let type4 = "";
                let type5 = "";
                let type6 = "";
                let type7 = "";


                if (file1 != [] && file1 != null && typeof (file1) != "undefined") {
                    type1 = file1.name.substring(file1.name.lastIndexOf("."));
                    fileParams.append('files', file1, "idPath" + type1);
                } /*else {
                    this.showMessage(1, "请上传身份证或户口本！");
                    return;
                }*/

                if (file2 != [] && file2 != null && typeof (file2) != "undefined") {
                    type2 = file2.name.substring(file2.name.lastIndexOf("."));
                    fileParams.append('files', file2, "studentPath" + type2);
                } /*else {
                    this.showMessage(1, "请上传学籍证明！");
                    return;
                }*/
                if (file3 != [] && file3 != null && typeof (file3) != "undefined") {
                    type3 = file3.name.substring(file3.name.lastIndexOf("."));
                    fileParams.append('files', file3, "insurancePath" + type3);
                } /*else {
                    this.showMessage(1, "请上传保险单据！");
                    return;
                }*/
                if (file4 != [] && file4 != null && typeof (file4) != "undefined") {
                    type4 = file4.name.substring(file4.name.lastIndexOf("."));
                    fileParams.append('files', file4, "photoPath" + type4);
                }


                if (file5 != [] && file5 != null && typeof (file5) != "undefined") {
                    type5 = file5.name.substring(file5.name.lastIndexOf("."));
                    fileParams.append('files', file5, "certPath" + type5);
                }

                if (file6 != [] && file6 != null && typeof (file6) != "undefined") {
                    type6 = file6.name.substring(file6.name.lastIndexOf("."));
                    fileParams.append('files', file6, "chargePath" + type6);
                }

                if (file7 != [] && file7 != null && typeof (file7) != "undefined") {
                    type7 = file7.name.substring(file7.name.lastIndexOf("."));
                    fileParams.append('files', file7, "rankPath" + type7);
                }


                this.showLoad = true;
                let header = "Content-Type': 'multipart/form-data";

                let mobile = that.formData.phone+","+this.matchId+","+'N';
                setTimeout(function () {
                    postAction("/sys/competition/importImg/" + mobile, fileParams, header).then((res) => {
                        that.showLoad = false;
                        if (res.success) {
                            params["idPath"] = res.result.idPath;
                            params["studentPath"] = res.result.studentPath;
                            params["insurancePath"] = res.result.insurancePath;
                            params["certPath"] = res.result.certPath;
                            params["rankPath"] = res.result.rankPath;
                            params["photoPath"] = res.result.photoPath;
                            params["chargePath"] = res.result.chargePath;
                            postAction("/sys/competition/edit", params).then((res) => {
                                if (res.success) {
                                    that.formData.file1 = null;
                                    that.formData.file2 = null;
                                    that.formData.file3 = null;
                                    that.formData.file4 = null;
                                    that.formData.file5 = null;
                                    that.formData.file6 = null;
                                    that.formData.file7 = null;
                                    this.file1List = [];
                                    this.file2List = [];
                                    this.file3List = [];
                                    this.file4List = [];
                                    this.file5List = [];
                                    this.file6List = [];
                                    this.file7List = [];
                                    that.formData.title = "";
                                    that.formData.phone = "";
                                    that.formData.captcha = "";
                                    that.formData.gradeName = "";
                                    that.resetForm();

                                    let code = res.result;
                                    that.qrVisible = true;
                                    /* that.$router.push({
                                        name: 'teamResult',
                                        params: { code: code},
                                        query:{t:Date.now()}
                                    });*/

                                    that.showMessage(0, "修改成功");
                                    that.isEdit=false;

                                    return;
                                } else {
                                    that.showMessage(1, res.message);
                                    return;
                                }
                            })

                        } else {
                            that.showLoad = false;
                            that.showMessage(1, "修改失败：" + res.message);
                        }


                    });
                },1000);

            },

            cancelEdit(){
                this.isEdit=false;
            },


            // 处理图片
            imgPreview(file,type) {
                let self = this
                // 看支持不支持FileReader
                if (!file || !window.FileReader) return;
                const size = file.size/1024
                /* console.log(`图片大小 ===> ${file.size/1024}k`);
                 console.log('图片压缩：',this.compressSwitch?'开':'关');
                 console.log('图片压缩阈值：',this.threshold+'k');
                 console.log('图片压缩降帧值：',this.quality);*/
                //if (/^image/.test(file.type) && size >= this.threshold && this.compressSwitch) {
                // 创建一个reader
                let reader = new FileReader()
                // 将图片2将转成 base64 格式
                reader.readAsDataURL(file)
                // 读取成功后的回调
                reader.onloadend = function() {
                    let result = this.result
                    let img = new Image()
                    img.src = result
                    img.onload = function() {
                        // 压缩
                        let data = self.compress(img,file.name,file.type)
                        console.log(`压缩后 ===>${data.fileData.size/1024}k`);
                        //self.$attrs.value[index].content = data.base64Data
                        file = data.fileData;
                        if(type=="1"){
                            self.formData.file1 = file;
                        }
                        else if(type=="2"){
                            self.formData.file2 = file;
                        }
                        else if(type=="3"){
                            self.formData.file3 = file;
                        }
                        else if(type=="4"){
                            self.formData.file4 = file;
                        }
                        else if(type=="5"){
                            self.formData.file5 = file;
                        }
                        else if(type=="6"){
                            self.formData.file6 = file;
                        }
                        else if(type=="7"){
                            self.formData.file7 = file;
                        }


                    }
                }
                //}
            },
            // 压缩图片
            compress(img, name, type) {
                let canvas = document.createElement('canvas')
                let ctx = canvas.getContext('2d')
                //瓦片canvas
                let tCanvas = document.createElement('canvas')
                let tctx = tCanvas.getContext('2d')
                // let initSize = img.src.length;
                let width = img.width
                let height = img.height
                //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
                let ratio
                if ((ratio = (width * height) / 4000000) > 1) {
                    // console.log("大于400万像素");
                    ratio = Math.sqrt(ratio)
                    width /= ratio
                    height /= ratio
                } else {
                    ratio = 1
                }
                canvas.width = width
                canvas.height = height
                //    铺底色
                ctx.fillStyle = '#fff'
                ctx.fillRect(0, 0, canvas.width, canvas.height)
                //如果图片像素大于100万则使用瓦片绘制
                let count
                if ((count = (width * height) / 1000000) > 1) {
                    // console.log("超过100W像素");
                    count = ~~(Math.sqrt(count) + 1) //计算要分成多少块瓦片
                    //      计算每块瓦片的宽和高
                    let nw = ~~(width / count)
                    let nh = ~~(height / count)
                    tCanvas.width = nw
                    tCanvas.height = nh
                    for (let i = 0; i < count; i++) {
                        for (let j = 0; j < count; j++) {
                            tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh)
                            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh)
                        }
                    }
                } else {
                    ctx.drawImage(img, 0, 0, width, height)
                }
                //进行压缩
                let ndata = canvas.toDataURL('image/jpeg', this.quality)
                tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
                return {base64Data:ndata,fileData:this.dataURLtoFile(ndata,name,type)}
            },
            //将base64转换为文件
            dataURLtoFile(dataurl,name,type) {
                name = name ? name : '图片'
                type = type ? type : 'jpg'
                var arr = dataurl.split(','),
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n)
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n)
                }
                return new File([u8arr], name, {
                    type: type
                })
            },


            rowClick(row){
                this.dialogVisible=false;
                this.formData.org = row.title;
                this.formData.orgCode = row.code;
                console.log(row)
            },

            onSearch(){
                let params={};
                let that=this;
                this.finished=false;
                setTimeout(function () {
                    getAction("/sys/competition/getTeam?name="+that.searchKey+"&matchId="+that.matchId, params).then((res) => {
                        if (res.success) {
                            that.finished=true;

                            if(res.result.length==0){
                                that.showMessage(1,"查询为空");
                            }else{
                                let tmplist = [];
                                for (let i=0;i<res.result.length;i++){
                                    let tmp={title:"",code:""};
                                    tmp["title"]= res.result[i]["title"];
                                    tmp["code"]= res.result[i]["code"];
                                    tmp["type"]= res.result[i]["type"];
                                    tmplist.push(tmp);
                                }

                                that.tableData = tmplist;
                            }

                        } else {
                            that.finished=true;
                            that.showMessage(1,res.message);
                        }
                    });
                    that.finished=true;
                },500);

            },
            resetForm() {
                this.$refs['elForm'].resetFields();
                this.formData.orgCode="";
                this.formData.gradeName="";
                this.file1List=[];
                this.file2List=[];
                this.file3List=[];
                this.file4List=[];
                this.file5List=[];
                this.file6List=[];
                this.file7List=[];
                this.formData.file1=null;
                this.formData.file2=null;
                this.formData.file3=null;
                this.formData.file4=null;
                this.formData.file5=null;
                this.formData.file6=null;
                this.formData.file7=null;

            },
            onOpen() {
                this.dialogVisible=true;
            },
            onClose() {
                this.dialogVisible=false;
                //this.$refs['elForm'].resetFields()
            },
            close() {
                this.dialogVisible=false;
                //this.$emit('update:visible', false)
            },
            handelConfirm() {
                this.dialogVisible=false;
                /*this.$refs['elForm'].validate(valid => {
                    if (!valid) return
                    this.close()
                })*/
            },
            qrClose(){
                this.qrVisible=false;
            },
            getEditFile(file){
                this.formData.file1 = file.raw;
            },
            getLoad(e){
                console.log("加载成功");
                console.log(e);

            },

            doUpdate(){
                if(!this.showProgress){
                    this.showMessage(1,"请先查询报名信息");
                    return;
                }

                this.formData.id = this.checkItem.id;
                this.formData.title = this.checkItem.title;
                this.formData.idNumber = this.checkItem.idNumber;
                this.formData.sex = this.checkItem.sex;
                this.formData.gradeName = this.checkItem.grade;
                this.formData.school = this.checkItem.school;
                this.formData.des = this.checkItem.des;
                this.formData.org = this.checkItem.org;
                this.formData.orgCode = this.checkItem.orgCode;
                this.formData.birthday = this.checkItem.birthday;
                this.formData.phone = this.formData.checkPhone;

                let prefix = 'http://img.tmxiangqi.com/person/'+this.matchId+'/'+this.checkItem.phone+'/';
                let suffix = "?timestamp="+Date.now();
                if(!this.checkNull(this.checkItem.idPath)){
                    this.file1List=[{name: this.checkItem.idPath, url:prefix+this.checkItem.idPath+suffix}];
                    this.file1Img = prefix+this.checkItem.idPath+suffix;
                }

                if(!this.checkNull(this.checkItem.studentPath)){
                    this.file2List=[{name: this.checkItem.studentPath, url:prefix+this.checkItem.studentPath+suffix}];
                    this.file2Img = prefix+this.checkItem.studentPath+suffix;
                }
                if(!this.checkNull(this.checkItem.insurancePath)){
                    this.file3List=[{name: this.checkItem.insurancePath, url:prefix+this.checkItem.insurancePath+suffix}];
                    this.file3Img = prefix+this.checkItem.insurancePath+suffix;
                }
                if(!this.checkNull(this.checkItem.certPath)){
                    this.file5List=[{name: this.checkItem.certPath, url:prefix+this.checkItem.certPath+suffix}];
                    this.file5Img = prefix+this.checkItem.certPath+suffix;
                }
                if(!this.checkNull(this.checkItem.rankPath)){
                    this.file7List=[{name: this.checkItem.rankPath, url:prefix+this.checkItem.rankPath+suffix}];
                    this.file7Img = prefix+this.checkItem.rankPath+suffix;
                }
                if(!this.checkNull(this.checkItem.chargePath)){
                    this.file6List=[{name: this.checkItem.chargePath, url:prefix+this.checkItem.chargePath+suffix}];
                    this.file6Img = prefix+this.checkItem.chargePath+suffix;
                }


                this.showCheck=false;
                this.isEdit = true;
            },

            checkNull(item){
                if(item==null||item==""||typeof(item)=="undefined"){
                    return true;
                }
                else{
                    return false;
                }
            },

        }
    }

</script>
<style>
    .transition-box {
    }
</style>



// WEBPACK FOOTER //
// src/views/person/index.vue